import { GET } from "../../../API/get";
import { getFirebaseDisputes } from "../../../utils";
import { disputesRef } from "../../../firebase";
import { getUserInfo } from "../../../storage";
import { POST } from "../../../API/post";

export const openDisputeChatView = async (job_id, dispatch) => {
    try {
        const dispute = await getFirebaseDisputes(job_id);
        if (Object.keys(dispute).length > 0) {
            const ref = disputesRef.doc(dispute.id);

            await updateFirebaseDocument(ref);

            dispatch({
                type: 'SET_DISPUTESCHAT',
                disputesChat: {
                    is_show: true,
                    dispute:{
                        doc_id: dispute.id,
                        ...dispute,
                    }
                }
            });
        } else {
            console.error("Dispute not found for job ID:", job_id);
        }
    } catch (error) {
        console.error("Error opening chat document:", error);
    }
};

export const fetchDispute = async ({doc_id}) => {
    const response = await GET(`dispute/firebase/${doc_id}`);
    return response.status === "Success" ? response : null;
};

const updateFirebaseDocument = async (ref) => {
    const user_info = getUserInfo();

    await ref.update({
        [`${ref.path.split('/')[0]}_last_message_seen_user`]: user_info.admin_firebase_document_id,
        [`${ref.path.split('/')[0]}_last_message_seen_timestamp`]: new Date().getTime(),
    });
};

export const fetchJobs = async (dispatch, startAfterDoc = null) => {
    dispatch({
        type: 'SET_LOADING',
        loading: true
    })

    const pageSize = 5;

    try {
        let query = disputesRef.orderBy('dispute_id', 'desc').limit(pageSize);

        if (startAfterDoc) {
            query = query.startAfter(startAfterDoc);
        }

        const snapshot = await query.get();

        if (snapshot.empty) {
            dispatch({ 
                type: 'SET_IS_END',
                isEnd: true,
                loading: false
            })
            return;
        }

        const docs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        dispatch({ 
            type: 'SET_DISPUTES', 
            disputes: docs,
            lastDoc: snapshot.docs[snapshot.docs.length - 1],
            isEnd: snapshot.docs.length < pageSize,
            loading: false
        });
    } catch (error) {
        console.error('Error fetching disputes:', error);
        dispatch({
            type: 'SET_LOADING',
            loading: false
        })
    }
};

export const createCreditNote = async (job_id) => {
    const response = await POST(`payment/refund`, { job_id });
    return response?.status === "Success" ? response : null;
};